// extracted by mini-css-extract-plugin
export default {"root":"_15RL3","table":"_7B4V_","acceptButton":"FMkrc","cancelButton":"_19RH1"};